import api from '@/services/api'

export default {
  sendNotification(data) {
    return api.post('/notification', data);
  },
}